export default __webpack_public_path__ + "static/3-defence-30d9e594d363170ae5991a3f4a5152eb.jpeg";